'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
require('react');
var reactGoogleRecaptchaV3 = require('react-google-recaptcha-v3');

function RecaptchaProvider({ reCaptchaKey, hideBadge, children }) {
    return reCaptchaKey ? /*#__PURE__*/ jsxRuntime.jsxs(reactGoogleRecaptchaV3.GoogleReCaptchaProvider, {
        reCaptchaKey: reCaptchaKey,
        // useEnterprise
        scriptProps: {
            async: false,
            defer: true,
            appendTo: 'body',
            nonce: undefined
        },
        container: {
            parameters: {
                badge: 'inline'
            }
        },
        children: [
            children,
            hideBadge && /*#__PURE__*/ jsxRuntime.jsx("style", {
                children: `.grecaptcha-badge { visibility: hidden; }`
            })
        ]
    }) : /*#__PURE__*/ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: children
    });
}

module.exports = RecaptchaProvider;
